import showToast from '@Common/toast/showToast';
import { useGeneratorContext } from '@Context/GeneratorContext';
import { useQueueContext } from '@Context/QueueContext';
import { IssueDescrip } from '@Models/types';
import { Backspace, Trash } from '@phosphor-icons/react';

const Subtasks = () => {
  const {
    selectedSubtasks,
    setSelectedSubtasks,
    generateTestCases,
    selectedPrompt,
  } = useGeneratorContext();
  const { addToQueue } = useQueueContext();

  const removeRequirement = (item: IssueDescrip) => {
    const filtered = selectedSubtasks.filter((i) => i.key !== item.key);
    setSelectedSubtasks(filtered);
  };

  const handleGenerate = async () => {
    showToast.info('Generating Test Cases', 'generate-tc');
    setSelectedSubtasks([]);
    const queue = await generateTestCases(selectedSubtasks);
    addToQueue(queue.queueId, false);
  };

  const clearSubtasks = () => {
    setSelectedSubtasks([]);
  };

  return (
    <>
      <div className="flex flex-row items-center justify-between pb-2 text-xs sm:text-sm">
        <div>Subtasks</div>
        <Trash
          data-testid="test-requirements-clear-btn"
          onClick={() => clearSubtasks()}
          size={20}
          className="cursor-pointer hover:text-brandRed-500"
        />
      </div>

      {/* Add prompt override indicator */}
      {selectedPrompt && (
        <div className="mb-2 rounded-md border border-blue-200 bg-blue-50 p-2 text-xs">
          <div className="font-medium text-blue-700">
            Prompt Override Active
          </div>
          <div className="text-blue-600">
            Using: Version {selectedPrompt.version}
            {selectedPrompt.nickname && ` - ${selectedPrompt.nickname}`}
          </div>
        </div>
      )}

      {selectedSubtasks.length === 0 && (
        <div className="px-2 text-xs italic">No Requirements Added</div>
      )}

      <div className="flex flex-col gap-y-2">
        <div className="flex flex-col gap-y-2">
          {selectedSubtasks.length > 0 &&
            selectedSubtasks.map((req, index) => (
              <div
                key={index}
                className="flex flex-row items-center justify-between rounded-md bg-gray-200 px-4 py-2"
              >
                <span className="flex flex-row items-center gap-x-2 text-xs sm:text-sm">
                  <div>{req.key}</div>
                </span>

                <Backspace
                  role="button"
                  size={20}
                  onClick={() => removeRequirement(req)}
                  weight="regular"
                  className="cursor-pointer hover:text-brandRed-500"
                />
              </div>
            ))}
        </div>

        {selectedSubtasks.length > 0 && (
          <button
            onClick={handleGenerate}
            className="rounded-lg bg-primary-700 font-bold text-white hover:bg-primary-500 disabled:bg-white disabled:text-brandWarning-500"
          >
            <div className="px-4 py-2 text-xs">Generate Test Cases</div>
          </button>
        )}
      </div>
    </>
  );
};

export default Subtasks;
